import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Products.css";
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';


function Products() {
  useEffect(() => {
    AOS.init({
      duration: 1200,     // Durasi animasi 1000ms
      easing: 'ease-in-out',
      once: false,        // animasi bisa muncul saat scroll naik & turun
      mirror: true        // animasi juga muncul saat scroll ke atas
    });
    AOS.refresh();
    fetchProducts();
  }, []);

  const [search, setSearch] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [productsData, setProductsData] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Function to fetch products from the backend
  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await fetch('/backend/get_products.php', { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        setProductsData(data.products);
      } else {
        setMessage(data.message || 'Failed to fetch products.');
      }
    } catch (err) {
      setMessage('Server error: Could not fetch products.');
    } finally {
      setLoading(false);
    }
  };
  
  const kategoriList = [
    ...new Set([
      "All",
      ...productsData
        .map(item => item.category)
        .filter(Boolean)
    ])
  ];

  const filteredProducts = productsData.filter((product) => {
    const matchesSearch = product.name.toLowerCase().includes(search.toLowerCase());
    const matchesCategory =
      selectedCategory === "All" || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleBack = () => setSelectedProduct(null);

  return (
    <>
      <div className="container py-5">
        {!selectedProduct ? (
          <>
            <h1 className="mb-4 text-center products-title">Our Products</h1>

            {/* Search */}
            <div className="mb-3 d-flex justify-content-center">
              <input
                type="text"
                className="form-control product-search-input"
                placeholder="Search product..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* Kategori */}
            <div className="mb-4 d-flex flex-wrap justify-content-center gap-2">
              {kategoriList.map((kategori) => (
                <button
                  key={kategori}
                  className={`category-btn ${selectedCategory === kategori ? "active" : ""}`}
                  onClick={() => setSelectedCategory(kategori)}
                >
                  {kategori}
                </button>
              ))}
            </div>

            {/* Grid Produk */}
            <div className="row">
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="col-6 col-md-3 mb-4"
                  onClick={() => setSelectedProduct(product)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card h-100 shadow-sm product-card">
                    <img
                      src={product.media[0].src}
                      alt={product.name}
                      className="card-img-top product-img"
                    />
                    <div className="card-body">
                      <h5 className="card-title text-truncate">{product.name}</h5>
                      <p className="text-danger fw-bold">
                        Rp{product.price.toLocaleString()}
                      </p>
                      <p className="text-muted small mb-0">
                        ⭐ {product.rating} | {product.location}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          // Detail Produk
          <div>
            <button className="btn btn-outline-secondary mb-4" onClick={handleBack}>
              <FaArrowLeft className="me-2" />
            </button>

            <div className="row">
              <div className="col-md-5">
                <div id="productCarousel" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {selectedProduct.media.map((item, index) => (
                      <div
                        className={`carousel-item ${index === 0 ? "active" : ""}`}
                        key={index}
                      >
                        {item.type === "image" ? (
                          <img
                            src={item.src}
                            className="d-block w-100 rounded"
                            alt={`Media ${index}`}
                          />
                        ) : (
                          <video autoPlay muted loop playsInline className="d-block w-100 rounded">
                            <source src={item.src} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                    ))}
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#productCarousel"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#productCarousel"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>

              <div className="col-md-7">
                <h2>{selectedProduct.name}</h2>
                <p className="text-danger fw-bold fs-4">
                  Rp{selectedProduct.price.toLocaleString()}
                </p>
                <p className="text-muted">
                  ⭐ {selectedProduct.rating} | {selectedProduct.location}
                </p>
                <p>{selectedProduct.description}</p>
                <button className="btn btn-warning">Buy Now</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* FOOTER SECTION */}
      <div className="footer-section text-white section-fade" style={{ backgroundColor: "#754c24" }} data-aos="fade-up">
              <div className="container-fluid px-0">
                <div className="row g-0">
                  <div className="col-md-3 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#5c3e1c", position: "relative" }}>
                    <img
                      src="/images/dotwall.jpg"
                      alt="FORMEB Logo"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    />
                    <div className="text-center py-4 px-3" style={{ zIndex: 1, position: "relative" }}>
                      <img src="/images/logo.png" alt="FORMEB Logo" style={{ maxWidth: "350px" }} />
                      <p className="footer-tagline mt-2 fst-italic text-white">Foremost Living Style</p>
                    </div>
                  </div>
      
                  <div className="col-md-9 px-4 py-5">
                    <div className="row text-start">
                      <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                        <h5 className="footer-title text-white">PRODUCTS</h5>
                        <ul className="list-unstyled footer-links">
                          <li>Mattresses</li>
                          <li>Pillows</li>
                          <li>Foams</li>
                        </ul>
                      </div>
                      <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                        <h5 className="footer-title text-white">ABOUT US</h5>
                        <ul className="list-unstyled footer-links">
                          <li><Link to="/about#company-profile" className="text-white text-decoration-none">Company Profile</Link></li>
                          <li><Link to="/products#services" className="text-white text-decoration-none">Service</Link></li>
                          <li><Link to="/products#services" className="text-white text-decoration-none">Project Highlights</Link></li>
                          <li><Link to="/products#services" className="text-white text-decoration-none">Careers</Link></li>
                        </ul>
                      </div>
                      <div className="col-md-4 ps-4">
                        <h5 className="footer-title text-white">CONTACTS</h5>
                        <ul className="list-unstyled footer-links">
                          <li><Link to="/contact" className="text-white text-decoration-none">Contact</Link></li>
                          <li><Link to="/contact" className="text-white text-decoration-none">Our Location</Link></li>
                          <li className="mt-2">
                            <a href="mailto:xxxxxx@gmail.com" className="text-white me-3">
                              <i className="bi bi-envelope"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                              className="text-white"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-linkedin"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr className="text-light my-4" />
                    <div className="row">
                      <div className="col-md-6">
                        <p className="footer-email fw-bold text-white">contact@formeb.id</p>
                        <address className="footer-address text-white mt-2">
                          PT. FOREMOST MEBEL INDONESIA<br />
                          Jl. Gemilang, RT.002/RW.003, Tlajung Udik,<br />
                          Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                        </address>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4 small text-light">
                      ©2025 Foremost Mebel Indonesia. All Rights Reserved.
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </>
  );
}

export default Products;
